import React from 'react';

import { ClauseText } from './Components/ContractText';

const CashOffer = () => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Cash Offer
      </h2>
      <div className="mb-8">
        <ol className="list-decimal ml-6 space-y-1">
          <li>
            <span className="font-bold">Buyer</span> may elect to make this{' '}
            <span className="font-bold">Agreement</span> contingent upon
            obtaining mortgage financing. Regardless of any contingency in this
            Agreement, if <span className="font-bold">Buyer</span> chooses to
            obtain mortgage financing, the following terms apply:
          </li>
          <ol className="list-decimal ml-6 space-y-1">
            <li>
              <span className="font-bold">Buyer</span> will be in default of
              this Agreement if Buyer furnishes false information to anyone
              concerning Buyer’s financial and/or employment status, fails to
              cooperate in good faith with processing the mortgage loan
              application (including payment for and ordering of appraisal
              without delay), fails to lock in interest rate(s) as stated below,
              or otherwise causes the lender to reject, or refuse to approve or
              issue, a mortgage loan.
            </li>
            <li>
              <ClauseText>Within 7 days</ClauseText> from the{' '}
              <span className="font-bold">Execution Date</span> of this
              Agreement, Buyer will make a completed mortgage application
              (including payment for and ordering of credit reports without
              delay) for the mortgage terms and to the mortgage lender(s), if
              any, otherwise to a responsible mortgage lender(s) of Buyer’s
              choice. Broker for Buyer, if any, otherwise Broker for Seller, is
              authorized to communicate with the mortgage lender(s) to assist in
              the mortgage loan process. Broker for Seller, if any, is permitted
              to contact the mortgage lender(s) at any time to determine the
              status of the mortgage loan application.
            </li>
            <li>
              <span className="font-bold">Seller</span> will provide access to
              insurers’ representatives and, as may be required by the mortgage
              lender(s), to surveyors, municipal officials, appraisers, and
              inspectors.
            </li>
            <li>
              If the mortgage lender(s) gives{' '}
              <span className="font-bold">Buyer</span> the right to lock in
              interest rate(s) at or below the maximum levels desired, Buyer
              will do so at least{' '}
              <ClauseText>10 days before Settlement Date</ClauseText>.
            </li>
            <li>
              If the mortgage lender(s), or a property and casualty insurer
              providing insurance required by the mortgage lender(s), requires
              repairs to the <span className="font-bold">Property</span>, Buyer
              will, upon receiving the requirements, deliver a copy of the
              requirements to <span className="font-bold">Seller</span>. Within{' '}
              <ClauseText>7 days</ClauseText> of receiving the copy of the
              requirements, Seller will notify Buyer whether Seller will make
              the required repairs at Seller’s expense.
            </li>
            <ol className="list-decimal ml-6 space-y-1">
              <li>
                If Seller makes the required repairs to the satisfaction of the
                mortgage lender and/or insurer, Buyer accepts the Property and
                agrees to the Release clause in this Agreement.
              </li>
              <li>
                If Seller will not make the required repairs, or if Seller fails
                to respond within the stated time, Buyer will, within 7 Days,
                notify Seller of Buyer’s choice to:
              </li>
              <ol className="list-decimal ml-6 space-y-1">
                <li>
                  Make the repairs/improvements at Buyer’s expense, with
                  permission and access to the Property given by Seller, which
                  will not be unreasonably withheld (Seller may require that
                  Buyer sign a pre-settlement possession agreement such as the
                  Pre-Settlement Possession Addendum, which shall not, in and of
                  itself, be considered unreasonable), OR
                </li>
                <li>
                  Terminate this Agreement by written notice to Seller, with all
                  deposit monies returned to Buyer according to this Agreement.
                </li>
                <li>
                  If Buyer fails to respond within the time stated above or
                  fails to terminate this Agreement by written notice to Seller
                  within that time, Buyer will accept the Property, make the
                  required repairs/improvements at Buyer’s expense and agree to
                  the Release clause of this Agreement.
                </li>
              </ol>
              <li>
                The Loan-To-Value ratio (LTV) is used by lenders as one tool to
                help assess their potential risk of a mortgage loan. A
                particular LTV may be necessary to qualify for certain loans, or
                buyers might be required to pay additional fees if the LTV
                exceeds a specific level. The appraised value of the Property
                may be used by lenders to determine the maximum amount of a
                mortgage loan. The appraised value is determined by an
                independent appraiser, subject to the mortgage lender’s
                underwriter review, and may be higher or equal to the Purchase
                Price and/or market price of the Property.
              </li>
            </ol>
            <li>
              <span className="font-bold">Mortgage Contingency:</span> This sale
              is NOT contingent on mortgage financing, although{' '}
              <span className="font-bold">Buyer</span> may obtain mortgage
              financing and/or the parties may include an appraisal contingency.{' '}
              <span className="font-bold">Buyer</span> and{' '}
              <span className="font-bold">Seller</span> understand that the
              waiver of this contingency does not restrict Buyer’s right to
              obtain mortgage financing for the{' '}
              <span className="font-bold">Property</span>.
            </li>
          </ol>
        </ol>
      </div>
    </div>
  );
};

export default CashOffer;
